// extracted by mini-css-extract-plugin
module.exports = {"search-fade-in":"ServicesFeaturedServices_search-fade-in__M2w4W"};